import { Link, useParams } from "react-router-dom";
import methods from "../../services/utility";
// assets
import back from "../../assets/images/icons/arrow-right2.svg";
import UnderConstruction from "../public/underConstruction/UnderConstruction";
import house from "../../assets/images/icons/house-2.svg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const RestaurantWarehouse = () => {
  const { branchId, restaurantId } = useParams();

  return (
    <main className="col-md-9 col-lg-12 mx-md-auto vh-100">
      <div className="d-none d-lg-flex justify-content-start align-items-baseline mb-3">
        <Link to={`/${restaurantId}/dashboard`} className="link back-link">
          <span>
            <img src={back} className="" alt="return" />
          </span>
          بازگشت
        </Link>
      </div>
      <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
        <div className="d-md-flex justify-content-between align-items-baseline">
          <Link to="/dashboard" className="link back-link">
            <span>
              <img src={back} className="" alt="return" />
            </span>
          </Link>
          انبار
        </div>
        <p className="date">{methods.currentDate()}</p>
      </div>
      <div className="warehouse-wrapper">
        <Tabs
          defaultActiveKey="1"
          id="uncontrolled-tab-example"
          className="mb-3 warhouse-tab"
        >
          <Tab eventKey="1" title="اطلاعات بایه انبار">
            <div className="row g-3">
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  <div className="card-body">
                    <Link
                      to={`/warehouse/${restaurantId}/createCategoryWarehouse`}
                    >
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        مدیریت گروه انبار
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  <div className="card-body">
                    <Link to={`/warehouse/${restaurantId}/createWarehouse`}>
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        مدیریت انبارها
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  <div className="card-body">
                    <Link to={`/warehouse/${restaurantId}/supplierWarehouse`}>
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        تامین کننده
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  <div className="card-body">
                    <Link to={`/warehouse/${restaurantId}/purchaseOrder`}>
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        ثبت سفارش خرید
                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  <div className="card-body">
                    <Link
                      to={`/warehouse/${restaurantId}/createCategoryWarhouseTree`}
                    >
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        انبار
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </main>
  );
};

export default RestaurantWarehouse;
